<nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow"
     *ngIf="accountService.isLoggedIn()">
  <app-navigation-top></app-navigation-top>
</nav>

<div class="container-fluid"
     *ngIf="accountService.isLoggedIn()">
  <div class="row">

    <nav class="col-md-2 d-none d-md-block bg-light sidebar">
      <div class="sidebar-sticky">
        <app-navigation-side></app-navigation-side>
      </div>
    </nav>

    <main role="main" class="col-md-10 ml-sm-auto px-4"
          *ngIf="accountService.myAccountInfoIsLoaded()">
      <div class="alert alert-warning mt-3 mb-0" role="alert"
           *ngIf="shutdownBannerText() as text">{{ text }}</div>
      <router-outlet></router-outlet>
    </main>

    <main role="main" class="col-md-10 ml-sm-auto px-4"
         *ngIf="!accountService.myAccountInfoIsLoaded() && !accountService.getMyAccountServerError()">
      <div class="pt-3">
        <h2>Loading Account Info...</h2>
      </div>
    </main>

    <main role="main" class="col-md-10 ml-sm-auto px-4"
         *ngIf="accountService.getMyAccountServerError()">
      <div class="pt-3">
        <h2>Account Info Server Error: {{ accountService.getMyAccountServerError() }}</h2>
      </div>
    </main>

  </div>
</div>

<app-login [supportPinMode]="true"
           [permissionCheck]="permissionCheck"
           [siteName]="'Staff Site'"
           *ngIf="!accountService.isLoggedIn()"></app-login>
